var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shown)?_c('StreamBarcodeReader',{on:{"decode":_vm.onDecode,"loaded":function () { return _vm.onLoaded(); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }